<template>
  <p
    v-if="$slots.default"
    class="txt-error text-red text-xs italic mb-2"
  >
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: 'ErrorText'
}
</script>
